<template>
  <div class="rt-vertical-attr">
    <div class="label">
      {{ label }}
    </div>
    <div class="text">
      <slot>
        {{ text }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtVerticalAttr',
  props: {
    label: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="less" scoped>
.rt-vertical-attr {
  width: max-content;
  text-align: right;
  .label {
    font-size: 14px;
    line-height: 19px;
    color: #6388c2;
  }
}
</style>



// WEBPACK FOOTER //
// rtVerticalAttr.vue?78b674c4